export default "__VITE_ASSET__44d39dc5__"